$('#ourUsersStories').owlCarousel({
    loop: false,
    items: 2,
    nav: false,
    responsive:{
        0:{
            items: 1,
            margin: 0,
            center: false,
            autoWidth: false,
        },
        1024:{
            items: 2,
            margin: 31,
            center: true,
            autoWidth: true,
        }
    }
});

$('#storiesNext').on('click', function () {
    $('#ourUsersStories').trigger('next.owl.carousel');
});

$('#storiesPrev').on('click', function () {
    $('#ourUsersStories').trigger('prev.owl.carousel');
});
